import { render, staticRenderFns } from "./WhiteBlackList.vue?vue&type=template&id=4462a8ce&scoped=true";
import script from "./WhiteBlackList.vue?vue&type=script&lang=js";
export * from "./WhiteBlackList.vue?vue&type=script&lang=js";
import style0 from "./WhiteBlackList.vue?vue&type=style&index=0&id=4462a8ce&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4462a8ce", null);
export default component.exports;